<template>
  <div class="FilePreview mnclear">
    <Modal
      v-model="modal1"
      fullscreen
      class-name="ivu-modal-file_preview"
      :title="file_name[file_index]"
      :value="true">
      <!--      <iframe v-if="!showImg" style="width: 80vw;height:84vh;"-->
      <!--              :src="file_data"-->
      <!--              frameborder="0"></iframe>-->
      <!--      <img style="width: 700px" v-if="showImg" :src="file_data">-->

      <div v-if="fileType=='file'" style="width:736;margin:auto;">
        <h3>暂不支持该格式文件预览</h3>
      </div>
      <div v-if="fileType=='image'"
           style="width: 100%;height:90vh;overflow-y: auto;display:flex;justify-content:center;">
        <img style="height: 98%;width: auto;margin: 0 auto" :src="file_data" alt="">
      </div>
      <div v-if="fileType=='video'" style="width: 100%;height:90vh;overflow-y: auto">
        <video :src="file_data" width="736" height="414" controls="controls" autoplay="autoplay"
               controlslist="nodownload">
          <source :src="file_data" type="video/ogg"/>
          <source :src="file_data" type="video/mp4"/>
          <source :src="file_data" type="video/webm"/>
          <object :data="file_data" width="736" height="414">
            <embed width="736" height="414" :src="file_data"/>
          </object>
        </video>
      </div>
      <div v-if="fileType=='audio'" style="width: 100%;height:90vh;overflow-y: auto">
        <audio :src="file_data" controls="controls" controlslist="nodownload">
          播放器不支持该格式音频
        </audio>
      </div>

      <div v-if="fileType=='pdf'" style="width: 100%;height:90vh;display:flex;justify-content:center;overflow-y: auto">
        <iframe :src="file_dataPdf" width='100%' height='100%' frameborder='0'>
        </iframe>
      </div>
      <div v-if="fileType=='word'" style="width: 100%;height:90vh;display:flex;justify-content:center;overflow-y: auto">
        <vue-office-docx style="width: 100%;height:100%;" :src="file_data"/>
      </div>
      <div v-if="fileType=='excel'" style="width: 100%;height:90vh;display:flex;justify-content:center;overflow-y: auto">
        <vue-office-excel style="width: 100%;height:100%;" :src="file_data"/>
      </div>

      <div v-if="fileType=='ppt'" style="width: 100%;height:90vh;display:flex;justify-content:center;overflow-y: auto">
<!--        <iframe :src="'https://view.officeapps.live.com/op/view.aspx?src='+file_data" width='100%' height='100%'-->
<!--                frameborder='1'>-->
<!--        </iframe>-->
        <div id="pptx" v-if="file_data&&fileType=='ppt'" style="width: 100%;height:84vh;"></div>
      </div>


    </Modal>

    <div class="dis"
         v-for="(item,index) in file_name"
         :key="index">
      <div>{{ item }}</div>
      <div>
        <Button class="button mnclear"
                size="small"
                type="success"
                @click="preview(index)">预览
        </Button>
      </div>
    </div>
  </div>
</template>
<script>
import VueOfficeDocx from '@vue-office/docx'
import '@vue-office/docx/lib/index.css'
import VueOfficeExcel from '@vue-office/excel'
import '@vue-office/excel/lib/index.css'

export default {
  components: {
    VueOfficeExcel, VueOfficeDocx
  },
  props: {
    file_name: {
      type: [Array, String],
      default: ''
    },
    file: {
      type: [Array, String],
      default: ''
    }
  },
  data() {
    return {
      modal1: false,
      file_index: '',
      file_data: '',
      showImg: false,

      fileType: '',
      file_dataPdf: '',
    }
  },
  methods: {
    preview(index) {
      let that = this
      this.fileType = this.$fileTypeChange(this.file[index])
      if (this.fileType == 'pdf') {
        this.file_dataPdf = '/pdf/web/viewer.html?file=' + this.file[index]
      }else if (this.fileType == 'ppt') {
        that.file_data = that.file[index]
        setTimeout(function (){
          //一定要用定时器不然组件出来后不渲染ppt
          $("#pptx").pptxToHtml({
            pptxFileUrl: that.file_data, //pptx文件地址
            slidesScale: "100%",
            slideMode: false,
            keyBoardShortCut: false
          });
        },800)

      } else {
        this.file_data = this.file[index]
      }

      this.modal1 = true
    }
  },
  mounted() {
  },
  created() {
  }
}
</script>
<style lang="less">
.FilePreview {
  .dis {
    margin: 5px 0;
    display: flex;
    justify-content: space-between;
  }

  .button {
    margin: 0 5px;
  }

  .modal {
    width: 700px;

  }
}

.ivu-modal-file_preview {
  .ivu-modal {
    width: 100% !important;
    top: 0 !important;
  }
}
</style>
<style scoped>
/deep/ table {
  max-width: 100% !important;
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  text-align: center !important;
  border: 0px !important;
}

/deep/ table tr td {
  /* border: 1px solid gray !important; */
  border-right: 1px solid gray !important;
  border-bottom: 1px solid gray !important;
}

/**整体样式 */
/deep/ .excel-view-container {
  background-color: #FFFFFF;
}

/**标题样式 */
/deep/ .class4Title {
  font-size: 22px !important;
  font-weight: bold !important;
  padding: 10px !important;
}

/**表格表头样式 */
/deep/ .class4TableTh {
  /* font-size: 14px !important; */
  font-weight: bold !important;
  padding: 2px !important;
  background-color: #EFE4B0 !important;
}
</style>


